
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blogs",
      function () {
        return require("private-next-pages/blogs/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blogs"])
      });
    }
  